import { render, staticRenderFns } from "./DesignStudioV3.vue?vue&type=template&id=68952bb5&scoped=true"
import script from "./DesignStudioV3.vue?vue&type=script&lang=js"
export * from "./DesignStudioV3.vue?vue&type=script&lang=js"
import style0 from "./DesignStudioV3.vue?vue&type=style&index=0&id=68952bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68952bb5",
  null
  
)

export default component.exports